
import WebbProgressBar from "./webb-progressbar"

export default function UserScoreCard(props) {

  return (
    <>
    <div className="card p-3 rounded-wd bg-white mb-3">
      
      <div className="d-flex">
        <div className="me-auto">
          <p className="lead">Track1: Progress</p>
        </div>
        <div className="text-end">
        <p className="lead">60%</p>
        </div>
      </div>

      <WebbProgressBar stat={60}/>
      
    </div>
    </>
  )
}